import { List, ListItem, Typography, Divider, Box, Button, Paper, ListItemText } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useGetPartNumberDetails } from '../../data/DataProviders/GetPartNumberProvider';
import { useHistory } from 'react-router-dom';
import { GetPartNumberDetails, SubscriptionStatus } from '../../types/device';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { isDataLoaded } from '../../types';
import { pushAppRoute } from '../../data/domain/route-manager';
import ErrorIcon from '@mui/icons-material/Error';
import { DataIndicators } from '../../components/DataIndicators';
import moment from 'moment';
import { isRecordFound, useSelectedOrganizationData, useSelectedLocationData } from '../../hooks/data-hooks';



export const MeshSubscriptionInfo: React.FC<{ siteName: string }> = (props) => {
    const currentAppRoute = useCurrentAppRoute();
    const history = useHistory();
    const [product, setProduct] = useState<any>();
    const [quantity, setQuantity] = useState<any>();
    const [expirationDate, setExpirationDate] = useState<any>();
    const [activationId, setActivationId] = useState<any>();
    const [activationLevel, setActivationLevel] = useState<any>();
    const meshSubscriptionDetails = useGetPartNumberDetails();
    const [getPartNumberData, setGetPartNumberData] = useState<GetPartNumberDetails | null>(null);
    const subscription = getPartNumberData ? getPartNumberData.results : [];
    const [showError, setShowError] = useState(false);


    const selectedOrganization = useSelectedOrganizationData();
    const selectedLocation = useSelectedLocationData();


    useEffect(() => {
        if (isDataLoaded(meshSubscriptionDetails)) {
            setGetPartNumberData(meshSubscriptionDetails.value);
        }
    }, [meshSubscriptionDetails]);

    const navigateToAcquireSubscription = (): void => {
        if (currentAppRoute.type === 'MeshDeviceProfile') {
            pushAppRoute(history, {
                type: 'AcquireSubscription',
                deviceId: currentAppRoute.deviceId,
                locationId: currentAppRoute.locationId,
                orgId: currentAppRoute.orgId,
                siteId: currentAppRoute.siteId,
                subType: product,
            });
        }
    };

    useEffect(() => {
        if (getPartNumberData && subscription.length !== 0) {
            setProduct(subscription[0].partNumber);
            if (subscription[0].expirationDate !== null)
                setExpirationDate(moment(subscription[0].expirationDate.substring(0, 10)).format('MM/DD/YYYY'));
            else setExpirationDate('n.a');
            setActivationId(subscription[0].activationId);
            setActivationLevel(subscription[0].mappingHierarchy);
            setQuantity(`${subscription[0].fulFilledQuantity}/${subscription[0].totalQuantity}`);

            if (subscription[0].subscriptionStatus === SubscriptionStatus.Expired) {
                setShowError(true);
            } else {
                setShowError(false);
            }
        } else if (subscription.length === 0) {
            setProduct('--');
            setExpirationDate('--');
            setActivationId('--');
            setActivationLevel('--');
            setQuantity('0');
        }
    }, [getPartNumberData]);


    /* Get the activation level name based on the activation level
     when no name of activation level then just print --
    */
    const getActivationLevelName = () => {
        const orgName = isRecordFound(selectedOrganization)
            ? selectedOrganization.value.name
            : '';
        const location = isRecordFound(selectedLocation)
            ? selectedLocation.value.name
            : '';
        switch (activationLevel) {
            case 'Organization':
                return `(${orgName})` || 'Organization Name';
            case 'Location':
                return `(${location})` || 'Location Name';
            case 'Site':
                return `(${props.siteName})` || 'Site Name';
            default:
                return ''
        }
    };

    return (
        <>
            {!isDataLoaded(meshSubscriptionDetails) && (
                <DataIndicators
                    errorMessage="Subscription details not found"
                    emptyMessage="Subscription details not found"
                    inline
                    data={meshSubscriptionDetails}
                    emptyIcon="Devices"
                    isEmpty={false}
                    isDetailedInfo={false}
                />
            )}

            {isDataLoaded(meshSubscriptionDetails) && (
                <Box>
                    <>
                        <Paper>
                            <List data-testid="device-item">
                                <ListItem data-testid="device-name">
                                    <Typography variant="h6" color="primary">
                                        {' '}
                                        {`SUBSCRIPTIONS`}{' '}
                                    </Typography>
                                    <Typography style={{ marginLeft: 10 }}>
                                        {showError && (
                                            <ErrorIcon
                                                sx={{
                                                    fontSize: 30,
                                                    color: '#b60a0a',
                                                }}
                                            />
                                        )}
                                    </Typography>
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary={product} secondary="Subscription Type" />
                                </ListItem>
                                <Divider />
                                <ListItem>
                                    {showError ? (
                                        <ListItemText
                                            primary={expirationDate !== null ? expirationDate : null}
                                            secondary="Expire Date (Expired)"
                                            secondaryTypographyProps={{
                                                sx: {
                                                    color: '#b60a0a',
                                                },
                                            }}
                                        />
                                    ) : (
                                        <ListItemText primary={expirationDate} secondary="Expire Date" />
                                    )}
                                </ListItem>
                                <Divider />
                                <ListItem>
                                    <ListItemText primary={activationId} secondary="Activation ID" />
                                </ListItem>
                                <Divider />
                                <ListItem>
                                    <ListItemText primary={`${activationLevel} ${getActivationLevelName()}`} secondary="Activation Level" />
                                </ListItem>
                                <Divider />
                                <ListItem>
                                    <ListItemText
                                        primary={quantity}
                                        secondary="(fulfilled Quantity / Total Quantity)"
                                    />
                                </ListItem>
                                <Divider />
                                <Box
                                    style={{
                                        margin: 16,
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        data-testid="edit-action"
                                        onClick={navigateToAcquireSubscription}
                                    >
                                        Activate Subscription
                                    </Button>
                                </Box>
                            </List>
                        </Paper>
                    </>
                </Box>
            )}
        </>
    );
};
